import { Box, CircularProgress, Typography } from "@mui/material";

export const CircularProgressWithLabel = ({ value }: { value: number }) => (
	<Box position="relative" display="inline-flex">
		<CircularProgress variant="determinate" value={Math.min(100, value)} />
		<Box
			top={0}
			left={0}
			bottom={0}
			right={0}
			position="absolute"
			display="flex"
			alignItems="center"
			justifyContent="center"
		>
			<Typography variant="caption" component="div">
				{`${value}d`}
			</Typography>
		</Box>
	</Box>
);
